// extracted by mini-css-extract-plugin
export default {"tooltip":"PR-z","arrow":"QR-z"};